<template>
    <div class="team">
        <dl class="code type" v-loading="codeLoad">
            <dt>
                <em class="copy-code-button" :data-clipboard-text="codeData.code" @click="copy">一键复制</em>
                <div class="title">企业邀请码</div>
                <span>已邀请<big>
                        <font>{{codeData.count-codeData.limit}}</font>/{{codeData.count}}
                    </big>人</span>
            </dt>
            <dd>
                <div class="code-text">{{codeData.code}}</div>
                <div class="sign">注：个人会员暂不能升级为企业套餐</div>
            </dd>
        </dl>
        <dl class="account type">
            <dt>
                <div class="title">账号管理</div>
            </dt>
            <dd>
                <div class="company-name" v-loading="nameLoad">
                    <el-button type="text" icon="el-icon-edit-outline" v-if="!isEdit" @click="isEdit=true">编辑</el-button>
                    <el-button type="text" icon="el-icon-check" v-else @click="saveName" style="color:#3779ff">保存</el-button>
                    <label>我的企业名称</label>
                    <input type="text" placeholder="请输入所属公司名称" v-model="userInfo.companyName" :disabled="!isEdit">
                </div>
                <div class="table-title">套餐成员</div>
                <el-table :data="tableData" border style="width: 100%" v-loading="tableLoad" stripe>
                    <el-table-column type="index" width="50" align="center"></el-table-column>
                    <el-table-column prop="userName" label="账号" align="center">
                        <template slot-scope="scope">
                            {{userInfo.leader&&userInfo.userId==scope.row.userId?'主账号':scope.row.userName}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="userPhone" label="手机号码" align="center"></el-table-column>
                    <el-table-column prop="expirationTime" label="到期时间" align="center"></el-table-column>
                    <el-table-column prop="remark" label="备注" align="center"></el-table-column>
                    <el-table-column prop="address" label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row.userId)" style="color:#ee4444"
                                v-show="userInfo.userId!=scope.row.userId">删除</el-button>
                            <el-button size="mini" type="text" @click="handleRemark(scope.$index, scope.row.userId)" style="color:#3779ff">备注
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </dd>
        </dl>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import qs from 'qs';
import Clipboard from 'clipboard'
export default {
    components: {},
    computed: {
        ...mapGetters({ userInfo: "getUser" })
    },
    data() {
        return {
            codeData: {},
            tableData: [],
            isEdit: false,
            tableLoad: true,
            codeLoad: true,
            nameLoad: false
        };
    },
    mounted() {
        this.getCode();
        this.getTeam();
    },
    methods: {
        copy() {
            var clipboard = new Clipboard('.copy-code-button') // 这里可以理解为选择器，选择上面的复制按钮
            clipboard.on('success', e => {
                this.$message({
                    message: '复制成功',
                    type: 'success'
                });
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$message({
                    message: '复制失败',
                    type: 'warning'
                });
                // 释放内存
                clipboard.destroy()
            })
        },
        handleDelete(index, id) {
            this.$confirm(`是否确定删除${this.tableData[index].userName}的账户？删除后该员工不再具有该企业的VIP权限！`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.tableLoad = true;
                this.$http.post("/app/company/delGroupPerson", qs.stringify({
                    groupId: this.userInfo.companyId,
                    userId: id
                })).then(res => {
                    this.tableLoad = false;
                    if (res.data.code == 0) {
                        this.tableData.splice(index, 1);
                        this.$message.success('套餐成员已删除！');
                    }
                })
            }).catch(() => { });
        },
        handleRemark(index, id) {
            this.$prompt('请输入备注', '备注', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputType: 'textarea',
                inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                inputErrorMessage: '备注不能为空'
            }).then(({
                value
            }) => {
                this.tableLoad = true;
                this.$http.post("/app/company/addRemarks", qs.stringify({
                    userId: id,
                    remark: value
                })).then(res => {
                    this.tableLoad = false;
                    if (res.data && res.data.code == 0) {
                        this.tableData[index].remark = value;
                        this.$message.success('备注成功！');
                    }
                })
            }).catch(() => { });
        },
        saveName() {
            if (this.userInfo.companyName) {
                this.nameLoad = true;
                this.$http.post("/app/company/update", {
                    companyId: this.userInfo.companyId,
                    companyName: this.userInfo.companyName
                }).then(res => {
                    this.nameLoad = false;
                    if (res.data.code == 0) {
                        this.isEdit = false;
                        this.$store.commit("setUser", this.userInfo);
                        this.$message.success('姓名修改成功！')
                    }
                })
            }
        },
        getTeam() {
            this.$http.get(`/app/company/info/${this.userInfo.userId}`).then(res => {
                this.tableLoad = false;
                if (res.data.code == 0) {
                    this.tableData = res.data.data.userList;
                    this.tableData.forEach(ele => {
                        if (!ele.remark) {
                            ele.remark = '--'
                        }
                    });
                }
            })
        },
        getCode() {
            this.$http.get("/app/company/invitationCode").then(res => {
                this.codeLoad = false;
                if (res.data.code == 0) {
                    this.codeData = res.data.data;
                }
            })
        }
    },

}
</script>

<style lang="less" scoped>
.team {
    .type {
        margin-bottom: 20px;
        background-color: #fff;
        padding: 20px;

        &:last-child dt::after {
            width: 48px;
        }

        dt {
            margin-bottom: 15px;
            position: relative;

            &::after {
                position: absolute;
                left: 0;
                bottom: 0;
                content: "";
                width: 65px;
                height: 6px;
                background-color: #bed3fd;
                z-index: 2;
            }

            em {
                float: right;
                font-style: normal;
                background: url("../../assets/img/user/copy.png") left center
                    no-repeat;
                padding-left: 25px;
                cursor: pointer;
            }

            span {
                font-size: 14px;
                margin-left: 20px;
                color: #666;
                vertical-align: middle;

                big {
                    font-size: 16px;

                    font {
                        color: #3779ff;
                    }
                }
            }

            .title {
                display: inline-block;
                font-size: 16px;
                color: #343c4b;
                font-weight: bold;
                z-index: 10;
                position: relative;
            }
        }

        dd {
            .code-text {
                line-height: 60px;
                background-color: #f5f9ff;
                color: #3779ff;
                font-weight: bold;
                text-align: center;
            }

            .sign {
                margin-top: 15px;
                font-size: 12px;
                color: #ed4444;
            }

            .company-name {
                margin-bottom: 20px;

                button {
                    float: right;
                    margin-top: -10px;
                    color: #666;
                }

                label {
                    font-size: 14px;
                    font-weight: bold;
                }

                input {
                    display: block;
                    width: calc(100% - 40px);
                    border: #eeeeee 1px solid;
                    padding: 0 20px;
                    height: 40px;

                    &:disabled {
                        cursor: no-drop;
                    }
                }
            }

            .table-title {
                font-size: 14px;
                font-weight: bold;
                margin-bottom: 10px;

            }
        }
    }
}

/deep/.el-table thead {
    color: #666;
    font-weight: 600;
}

/deep/.el-table--border th {
    border-right: #eee 1px solid;
    background: #f5f5f5;
    font-weight: 600;
}

/deep/.el-table td,
/deep/.el-table th.is-leaf {
    border-bottom: #eee 1px solid;
    font-size: 12px;
    font-weight: 600;
}

/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #f5f5f5;
}
/deep/.el-table td{
    color: #333;
}
</style>
